// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/modules.scss
// module id = ./resources/assets/sass/modules.scss
// module chunks = 0